import { Module } from '@interfaces/fc-user/permissions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const practitionerModulesSlice = createSlice({
    name: 'practitioner-modules',
    initialState: {
        modules: [],
    } as {modules: Module[]},
    reducers: {
        setPractitionerModules: (state, action: PayloadAction<Module[]>) => {
            state.modules = action.payload;
        },
        cleanPractitionerModules: (state) => {
            state.modules = [];
        },
    },
});

export const { setPractitionerModules,cleanPractitionerModules } = practitionerModulesSlice.actions;
export default practitionerModulesSlice.reducer;
